define('ordersDetailOrderProductOptionEditMixableOptionsView',[
  'module',
  'backbone',
  'underscore',
  'compositeView',
  'buttonView',
  'ordersDetailOrderProductOptionEditMixableOptionView',
  'template!ordersDetailOrderProductOptionEditMixableOptionsView'
], function (
  Module,
  Backbone,
  _,
  CompositeView,
  ButtonView,
  OptionView,
  Tpl
) {
  'use strict';

  Module.exports = CompositeView.extend({
    template: Tpl,
    childView: OptionView,  
    className: 'mixable-options-view',   

    childViewOptions: function () {
      return {
        product: this.options.product
      };
    },

    initialize: function() {
      this.collection = new Backbone.Collection(this.model.get('optionsMix'));     

      CompositeView.prototype.initialize.apply(this, arguments);
    },

    serializeData: function() {
      return {
        categories: this.options.product.get('productOptionCategories')
      };
    }
  });
});
